import { blinkConstants } from '@thoughtspot/blink-constants';
import _ from 'lodash';
import { useEffect, useState } from 'react';
function getErrorObjectFromGraphQLErrors(graphqlError, query, errorMappingContext) {
    const nwError = graphqlError?.networkError;
    if (!nwError?.result?.errors &&
        _.isEmpty(graphqlError?.graphQLErrors)) {
        return [
            {
                queryName: query?.definitions
                    ?.map((def) => def?.name?.value || '')
                    .join(','),
                code: 'NW_ERROR',
                message: '',
                errorObj: nwError,
                errorMappingContext,
            },
        ];
    }
    const errs = graphqlError?.networkError?.result?.errors ||
        graphqlError?.graphQLErrors;
    if (!errs)
        return undefined;
    const errors = errs.map(e => {
        return {
            queryName: query?.definitions
                ?.map((def) => def?.name?.value || '')
                .join(','),
            code: e?.extensions?.code || 'ERROR_UNKNOWN_ERROR',
            message: e?.message,
            errorObj: e,
            errorMappingContext,
        };
    });
    return errors;
}
const containsError = (errorList, errorCodes) => {
    if (!(errorList && errorCodes))
        return false;
    if (errorCodes.indexOf('*') !== -1) {
        return true;
    }
    if (errorList.some(e => errorCodes.includes(e.code))) {
        return true;
    }
    return false;
};
const containsInApolloError = (error, errorCodes) => {
    if (!(error && errorCodes))
        return false;
    const errorList = getErrorObjectFromGraphQLErrors(error);
    return containsError(errorList, errorCodes);
};
const useResetErrorOnStateChange = (errors, resetErrors, state) => {
    const [prevState, setPrevState] = useState(undefined);
    useEffect(() => {
        if (errors.length !== 0) {
            if (prevState === undefined) {
                setPrevState(state);
            }
            else if (prevState !== state) {
                resetErrors();
                setPrevState(undefined);
            }
        }
    }, [prevState, state]);
};
const shouldUseWarningBanner = (err) => {
    const ERROR_CODES_TO_USE_WARNING_BANNER = [
        blinkConstants.blinkGeneratedErrors.SAGE_INDEXING,
    ];
    return ERROR_CODES_TO_USE_WARNING_BANNER.includes(err?.code);
};
const containsInUpstreamError = (error, errorCodes) => {
    if (!(error && errorCodes))
        return false;
    const errorList = getErrorObjectFromGraphQLErrors(error);
    const upstreamErrorCodes = _.reduce(errorList, (errors, err) => {
        if (err.code !== 'UPSTREAM_FAILURE') {
            return errors;
        }
        errors.push(`${err?.errorObj?.extensions?.exception?.upstreamResponse?.data?.code}`);
        return errors;
    }, []);
    if (upstreamErrorCodes.length <= 0) {
        return false;
    }
    return _.some(upstreamErrorCodes, errCode => errorCodes.includes(errCode));
};
const getErrorCodeFromGraphQLErrors = (graphqlError) => {
    const errorObj = getErrorObjectFromGraphQLErrors(graphqlError) || [];
    const errorCode = errorObj[0]?.errorObj?.extensions.exception.upstreamResponse.data.code;
    return errorCode ? errorCode.toString() : undefined;
};
export { containsError, containsInApolloError, getErrorCodeFromGraphQLErrors, getErrorObjectFromGraphQLErrors, useResetErrorOnStateChange, shouldUseWarningBanner, containsInUpstreamError, };
//# sourceMappingURL=error-utils.js.map